import {twMerge} from '../../../common/twMerge';

/**
 * 폴더블 사이즈와 PC 사이즈에서 탑배너가 하나일 경우에만 사용하는 배경입니다. (운영에서 1개의 배너는 불가능하지만 예외처리를 위해 추가되었습니다.)
 * FoldableStandaloneTopBanner, PcStandaloneTopBanner에서 사용합니다.
 */
export function SingleImageBackground({bgImage}: {bgImage: string}) {
  return (
    <>
      <div
        className={twMerge(
          'absolute',
          'h-full w-full',
          'bg-cover bg-center bg-no-repeat',
          'blur-[16px]'
        )}
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
      />
      <div
        className={twMerge(
          'absolute',
          'h-full w-full',
          'bg-static-etc-dimmed opacity-70'
        )}
      />
    </>
  );
}
